import { useMemo } from "react"
import { useOpco } from "."
import { Opco } from "../models"

export function useFullBrandName(): string {
  const opco: Opco = useOpco()

  const brandName: string = useMemo<string>(() => {
    switch (opco) {
      case Opco.Noordhoff:
        return "Grote Bosatlas"
      case Opco.Plantyn:
        return "Digitale Wereldatlas"
    }
  }, [opco])

  return brandName
}
